import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import useSwitchBase from './CheckBox.hook'
import { BaseSwitch, Root, Section, Skeleton, Typography } from './Switch.styles'

export const useSwitch = useSwitchBase

/**
 * The Switch's component.
 */
const Switch = forwardRef((props, ref) => {
  const { checked, color, disabled, labelLeft, labelRight, loading, margin, onChange, padding, ...restProps } = props

  return (
    <Root margin={margin} padding={padding} ref={ref}>
      {loading && <Skeleton variant="rectangular" />}
      {labelLeft && (
        <Section loading={loading}>
          <Typography>{labelLeft}</Typography>
        </Section>
      )}
      <Section loading={loading}>
        <BaseSwitch
          {...restProps}
          checked={checked}
          color={color}
          disabled={disabled}
          size="small"
          onChange={onChange}
        />
      </Section>
      {labelRight && (
        <Section loading={loading}>
          <Typography>{labelRight}</Typography>
        </Section>
      )}
    </Root>
  )
})

Switch.defaultProps = {
  checked: false,
  color: 'primary',
  disabled: false,
  labelLeft: undefined,
  labelRight: undefined,
  loading: false,
  margin: 0,
  padding: 0
}

Switch.propTypes = {
  /**
   * Checked.
   */
  checked: PropTypes.bool.isRequired,
  /**
   * Color.
   */
  color: PropTypes.oneOf(['blank', 'default', 'error', 'primary', 'success', 'warning']),
  /**
   * Disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Label left.
   */
  labelLeft: PropTypes.string,
  /**
   * Label right.
   */
  labelRight: PropTypes.string,
  /**
   * Loading.
   */
  loading: PropTypes.bool,
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * On change.
   */
  onChange: PropTypes.func.isRequired
}

export default Switch
